import { LoginForm } from '@/components/login-form';
import { AuthShell } from '@/components/auth-shell';

export default function LoginPage() {
  return (
    <AuthShell>
      <div className="rounded-goutte border border-rule bg-white p-6 sm:p-8">
        <LoginForm />
      </div>
    </AuthShell>
  );
}
